<script setup lang="ts">
import type { ProductPlan } from '~/config'

const props = defineProps<ProductPlan>()

const showFullContent = ref(false)
const isContainerTooBig = computed(() => (props.highlights?.description?.length ?? 0) > 4)

const visibleHighlights = computed(() => {
  const content = props.highlights?.description?.filter((i) => !i.type || i.type === 'ITEM')

  if (!showFullContent.value) return content?.slice(0, 4)
  return content
})

watch(
  () => isContainerTooBig.value,
  (n) => {
    if (n) {
      showFullContent.value = false
    }
  }
)
</script>

<template>
  <CardComponent>
    <template #header>
      <div class="py-2 text-center text-2xl font-bold title-text">{{ name }}</div>
    </template>

    <div class="flex flex-col gap-6 p-4 items-stretch">
      <div class="flex flex-col gap-6">
        <div class="text-center">
          <span class="uppercase">— Desde —</span>
          <CoveragePrice
            :amount="price"
            :periodicity="subscription"
          />
        </div>
        <template v-if="highlights?.description?.length">
          <div class="flex flex-col items-stretch gap-4 overflow-hidden">
            <SeparatorHeader
              :text="highlights?.title?.length ? highlights?.title : 'Especificaciones'"
            />

            <div class="flex flex-col gap-2">
              <div
                v-if="highlights?.description?.filter((i) => i.type === 'NOTE').length"
                class="flex flex-col gap-2 mb-4"
              >
                <template
                  v-for="item in highlights?.description.filter((i) => i.type === 'NOTE')"
                  :key="item.label"
                >
                  <div class="rounded-md border border-surface-500 py-2 text-center text-xs">
                    <span>{{ item.label }}</span>
                  </div>
                </template>
              </div>
              <template
                v-for="(item, index) in visibleHighlights"
                :key="item.label"
              >
                <PvDivider v-if="index" />
                <div>
                  <div class="text-xs">
                    {{ item.label.charAt(0).toUpperCase() + item.label.slice(1).toLowerCase() }}
                  </div>
                  <div class="font-bold text-primary-200 text-base">{{ item.detail }}</div>
                </div>
              </template>
            </div>
          </div>
        </template>
      </div>
      <SeparatorHeader v-if="isContainerTooBig">
        <PvButton
          :label="showFullContent ? 'Ver menos' : 'Ver más'"
          size="small"
          @click="() => (showFullContent = !showFullContent)"
        />
      </SeparatorHeader>
    </div>
  </CardComponent>
</template>
